import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromptModalComponent } from './prompt-modal.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@NgModule({
    declarations: [PromptModalComponent],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
    ],
    exports: [PromptModalComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class PromptModalModule {}